export const getFullDateFormat = (locale: string) =>
  locale === "en" ? "MMM D, YYYY HH:mm" : "D MMM, YYYY HH:mm";
